import React from 'react';

import {BaseProps} from "../../../infrastructure/models/props/base-props";

export class ManualScrollerWrapperArrowProps extends BaseProps {
  className: String;
  activeClassName: String;
  isActive: Boolean;
  onClick: Function;
}

export const ManualScrollerWrapperArrow = (props: ManualScrollerWrapperArrowProps) => {
  const containerProp = {
    className: ['manual-scroll-wrapper-arrow-container', props.isActive && 'manual-scroll-wrapper-arrow-container-active'].join(' '),
    onClick: () => props.isActive && props.onClick()
  }

  const arrowClassName = [
    props.className, props.isActive && props.activeClassName].join(' ');

  return (
    <div {...containerProp}>
      <div className={arrowClassName}/>
    </div>
  )
};